import ApplicationModel, { attr } from '../ApplicationModel';
import { type CustomFieldOptionAttributes } from './generated/CustomFieldOptionAttributes';
import { model } from '../modelBuilder';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface CustomFieldOption
  extends CustomFieldOptionAttributes,
    IColorAttribute {}

@model
@ColorAttribute()
class CustomFieldOption extends ApplicationModel {
  // Start auto-generated
  static typename: 'CustomFieldOption' = 'CustomFieldOption';
  get typename(): 'CustomFieldOption' {
    return 'CustomFieldOption';
  }

  static internalTypename: 'CustomFieldOption' = 'CustomFieldOption';
  get internalTypename(): 'CustomFieldOption' {
    return 'CustomFieldOption';
  }

  static fields = {
    color: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    hidden: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    position: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated
}

export default CustomFieldOption;
